import { getResourceLocation } from '@finect/front-core/Routes';
import { getProductTypeBySlug } from './productTypes';
var getPartnerProductTypeSlug = function getPartnerProductTypeSlug(theme, productType) {
  var ptDefinition = getProductTypeBySlug(productType.slug);
  var _ref = theme.partner.iic || {},
    slugs = _ref.slugs;
  return slugs.hasOwnProperty(ptDefinition.id) ? slugs[ptDefinition.id] : productType.slug;
};
export var getFundsManagementCompaniesPath = function getFundsManagementCompaniesPath(theme, productType) {
  var slug = getPartnerProductTypeSlug(theme, productType);
  return getResourceLocation(theme, 'FundsManagementCompanies', {
    typeSlug: slug
  });
};
export var getManagementCompanyPath = function getManagementCompanyPath(theme, productType, managementCompany) {
  var slug = getPartnerProductTypeSlug(theme, productType);
  return getResourceLocation(theme, 'FundsManagementCompany', {
    typeSlug: slug,
    id: managementCompany.id,
    alias: managementCompany.alias
  });
};
export var getFundsCategoriesPath = function getFundsCategoriesPath(theme, productType, query) {
  var slug = getPartnerProductTypeSlug(theme, productType);
  return getResourceLocation(theme, 'FundsCategoriesTab', {
    typeSlug: slug,
    tab: 'todos'
  }, query || {});
};
export var getFundsComparisonPath = function getFundsComparisonPath(theme, productType) {
  var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var slug = getPartnerProductTypeSlug(theme, productType);
  return getResourceLocation(theme, 'FundsComparison', {
    typeSlug: slug
  }, query);
};
export var getFundsHomePath = function getFundsHomePath(theme, productType) {
  var slug = getPartnerProductTypeSlug(theme, productType);
  return getResourceLocation(theme, 'FundsHome', {
    typeSlug: slug
  });
};
export var getFundsListPath = function getFundsListPath(theme, productType, query) {
  var slug = getPartnerProductTypeSlug(theme, productType);
  return getResourceLocation(theme, 'FundsList', {
    typeSlug: slug
  }, query || {
    order: '-totalNetAsset'
  });
};
export var getFundsSheetPath = function getFundsSheetPath(theme, productType, fund) {
  var slug = getPartnerProductTypeSlug(theme, productType);
  return getResourceLocation(theme, 'FundSheet', {
    typeSlug: slug,
    isin: fund.isin,
    alias: fund.alias
  });
};
export var getFundsCategoryPath = function getFundsCategoryPath(theme, productType, category) {
  var slug = getPartnerProductTypeSlug(theme, productType);
  return getResourceLocation(theme, 'FundsCategory', {
    typeSlug: slug,
    id: category.id,
    alias: category.alias
  });
};